module.exports = __webpack_public_path__ + "static/media/10.question.01af5618.mp4";